/** The header's "New campaign" link. Renders nothing for staff who may not create one. */
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';

import { usePermissions } from '../../../hooks/usePermissions';
import { Permission } from '../../../types/permissions';
import { NEW_CAMPAIGN_PATH } from '../ticket-sales-campaigns-paths';

import './ticket-sales-campaigns-list.css';

export function NewTicketSalesCampaignButton() {
  const { hasPermission } = usePermissions();
  if (!hasPermission(Permission.WRITE_TICKET_SALES_CAMPAIGNS)) return null;

  return (
    <Link
      to={NEW_CAMPAIGN_PATH}
      className="nb-btn nb-btn-primary tsc-new-btn"
      aria-label="New campaign"
    >
      <Plus size={15} aria-hidden />
      New<span className="tsc-new-label-rest"> campaign</span>
    </Link>
  );
}
